import React from 'react';
import { ArcSkeleton, ArcStack } from '@src/core/ui';

const SidebarLoading: React.FC = () => {
  return (
    <ArcStack spacing={3}>
      <ArcSkeleton width={200} height={20} />
      <ArcStack spacing={1}>
        <ArcSkeleton width={150} height={20} />
        <ArcSkeleton width='100%' height={45} />
      </ArcStack>

      <ArcStack spacing={1}>
        <ArcSkeleton  width={150} height={20} />
        <ArcSkeleton width='100%' height={45} />
        <ArcStack spacing={1} direction='row'>
          <ArcSkeleton width='100%' height={45} />
          <ArcSkeleton width='100%' height={45} />
        </ArcStack>
      </ArcStack>

      <ArcStack spacing={1}>
        <ArcSkeleton width={150} height={20} />
        <ArcSkeleton width='100%' height={45} />
        <ArcSkeleton width='100%' height={45} />
      </ArcStack>
    </ArcStack>
  );
};

export default SidebarLoading;